// import { MDBBtn, MDBCard, MDBCardBody, MDBContainer, MDBIcon, MDBTypography } from "mdb-react-ui-kit";
import { Card, CardContent } from "@mui/material";
import "./ChatComponent.css"; // Import the CSS file for styling
// import DoubleClickDialog from "../../api/common/components/clickDialogue";
import TextSizeContext from "../../api/common/components/TextSizeContext";
// import ResponseComponent from "./ResponseComponent";
import AssistantSharpIcon from '@mui/icons-material/AssistantSharp';
import React, { useState,useRef,useEffect } from "react";


  interface Props {
    chatFollowUp: string;
    handleLike?: (index: number) => void;
    handleDislike?: (index: number) => void;
    likes?: ("like" | "dislike" | null)[];
    isLoading: boolean;
  }
  
  export default function FollowUpOutput({chatFollowUp, handleLike, handleDislike, likes, isLoading }:Props){
   
const chatHistoryRef = useRef<HTMLDivElement>(null);
  
    // Scroll to bottom function
    const scrollToBottom = () => {
      if (chatHistoryRef.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
      }
    };
  
    useEffect(() => {
      scrollToBottom();
    }, [chatFollowUp]);
    return (
      <>
      
       {/* <p className="dark">{chatFollowUp}</p>
       <br/> */}
        <div ref={chatHistoryRef} style={{ maxHeight: '400px', overflowY: 'auto' }}>

      <Card>
        <CardContent className="bot-response">
                      {/* <DoubleClickDialog /> */}
                           <AssistantSharpIcon/> <TextSizeContext context={chatFollowUp}></TextSizeContext>

          </CardContent>

      </Card>
          {/* ###Here add different loading previews alarms */}
        {isLoading && (
          <p className="text-info">
            <strong>loading: </strong>...
          </p>
        )}
    </div>  
 </>
  )};

// export {}